<template>
  <div class="question__answer-item question__image" :style="answerStyle" @click="onSelectedAnswer(answer)">
    <AnswerTooltip v-if="answer.paused">{{ tooltip }}</AnswerTooltip>
    <!-- nosem -->
    <h4 v-if="answer.headline" v-html="answer.headline"></h4>
    <img v-if="!useBackground" alt="" :src="answer.value" />
    <slot />
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { computed, defineComponent } from 'vue';
import AnswerTooltip from './AnswerItemTooltip.vue';
import type { GamePollAnswerState } from '@/src/components/games/poll/Model';
export default defineComponent({
  name: 'AnswerLayoutItem',
  components: { AnswerTooltip },
  props: {
    answer: {
      type: Object as PropType<GamePollAnswerState>,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    tooltip: {
      type: String
    },
    useBackground: {
      type: Boolean,
      required: true,
      default: true
    }
  },
  emits: ['selectedAnswer'],
  setup(props, context) {
    const answerStyle = computed(() => {
      if (props.answer.placement) {
        return {
          ...(props.useBackground && { backgroundImage: 'url(' + props.answer.value + ')' }),
          left: parseFloat('' + props.answer.placement?.x / (props.width / 100)).toFixed(2) + '%',
          top: parseFloat('' + props.answer.placement?.y / (props.height / 100)).toFixed(2) + '%',
          width: parseFloat('' + props.answer.placement?.w / (props.width / 100)).toFixed(2) + '%',
          height: parseFloat('' + props.answer.placement?.h / (props.height / 100)).toFixed(2) + '%'
        };
      } else {
        return '';
      }
    });

    const onSelectedAnswer = (answer: GamePollAnswerState) => {
      if (!props.answer.paused) {
        context.emit('selectedAnswer', answer);
      }
    };

    return {
      onSelectedAnswer,
      answerStyle
    };
  }
});
</script>
